<div class="page-head">
  <div>
    <h1>Cache</h1>
    <div class="sub">Every cached entry across the platform — evict without a redeploy</div>
  </div>
  <div class="head-actions">
    <ng-container *staffCan="'Platform.Cache.Purge'"><button type="button" class="act" (click)="flushCms()" [disabled]="busy">Flush CMS content</button></ng-container>
    <ng-container *staffCan="'Platform.Cache.Purge'"><button type="button" class="act act-danger" (click)="clearAll()" [disabled]="busy">Clear all caches</button></ng-container>
  </div>
</div>

<div class="page-body">
  <div class="panel">
    <div class="panel-title">Find &amp; evict by key</div>

    <div class="search-row">
      <input
        class="inp"
        type="text"
        [(ngModel)]="search"
        (keyup.enter)="load()"
        placeholder="Filter keys — e.g. Categor, Common_Countries, Business_&lt;id&gt;" />
      <button type="button" class="act" (click)="load()" [disabled]="busy">Search</button>
      <ng-container *staffCan="'Platform.Cache.Purge'"><button type="button" class="act act-ghost" (click)="clearMatching()" [disabled]="busy || !search.trim()">
        Clear matching
      </button></ng-container>
    </div>

    @if (message) {
      <div class="note note-ok">{{ message }}</div>
    }
    @if (error) {
      <div class="note note-err">{{ error }}</div>
    }

    @if (busy && !loaded) {
      <div class="key-count">Loading caches…</div>
    }

    @if (loaded && unconfigured.length > 0) {
      <div class="note note-warn">
        <strong>{{ unconfigured.length }} service{{ unconfigured.length === 1 ? '' : 's' }} not configured.</strong>
        @for (svc of unconfigured; track svc.service) { <span class="unconf-name">{{ svc.service }}</span> }
        <span class="unconf-hint">
          Their cache cannot be reached from here until a base URL is set on the account API
          (<code>Caching__Targets__&lt;Name&gt;</code>), with <code>Caching__InvalidationKey</code> holding
          the same secret on both sides. Clearing caches will not touch them.
        </span>
      </div>
    }

    @if (loaded) {
      <div class="key-count">
        {{ totalKeys }} key{{ totalKeys === 1 ? '' : 's' }} across {{ reachableCount }} of {{ services.length }} service{{ services.length === 1 ? '' : 's' }}
        @if (search.trim()) { <span>matching '{{ search.trim() }}'</span> }
      </div>

      @for (svc of services; track svc.service) {
        <div class="svc" [class.svc-down]="!svc.reachable" [class.svc-unconfigured]="svc.configured === false">
          <button type="button" class="svc-head" (click)="toggle(svc.service)" [disabled]="!svc.reachable || svc.keys.length === 0">
            <span class="svc-caret">{{ isExpanded(svc.service) ? '▾' : '▸' }}</span>
            <span class="svc-name">{{ svc.service }}</span>
            @if (svc.reachable) {
              <span class="svc-count">{{ svc.keys.length }}</span>
            } @else if (svc.configured === false) {
              <span class="svc-count svc-count-warn">not configured</span>
            } @else {
              <span class="svc-count svc-count-err">unreachable</span>
            }
          </button>

          <div class="svc-url">{{ svc.baseUrl }}</div>

          @if (svc.configured === false) {
            <div class="note note-warn">{{ svc.error }}</div>
          } @else if (!svc.reachable && svc.error) {
            <div class="note note-err">Could not read this service's cache: {{ svc.error }}</div>
          }

          @if (isExpanded(svc.service) && svc.keys.length > 0) {
            <ul class="key-list">
              @for (key of svc.keys; track key) {
                <li class="key-row">
                  <span class="key-text">{{ key }}</span>
                  <ng-container *staffCan="'Platform.Cache.Evict'"><button type="button" class="key-evict" (click)="evictKey(svc, key)" [disabled]="busy"
                          title="Evict this entry from {{ svc.service }}">✕</button></ng-container>
                </li>
              }
            </ul>
          }
        </div>
      }
    }

    <div class="hint">
      Listings come from each service's live in-memory cache, so they reflect that process only —
      a service running more than one instance reports the instance that answered. A service shown
      as <strong>unreachable</strong> was not asked successfully; that is not the same as having
      nothing cached.
    </div>
  </div>

  <div class="panel">
    <div class="panel-title">Terminal caches</div>

    <div class="search-row">
      <input
        class="inp"
        type="text"
        [(ngModel)]="purgeBusinessId"
        placeholder="Business id — leave blank for every terminal on the platform" />
      <ng-container *staffCan="'Platform.Cache.Purge'"><button type="button" class="act act-danger" (click)="purgeTerminals()" [disabled]="busy">
        Force clear terminal caches
      </button></ng-container>
    </div>

    <div class="hint">
      Deletes the data cached <strong>on the devices themselves</strong> — the POS app's
      IndexedDB store and legacy web-storage caches — not the server caches above. Terminals
      that are online purge immediately; terminals that are closed or offline purge on their
      next launch. Auth sessions and in-progress sales are untouched, and everything deleted
      re-downloads as screens are used.
    </div>
  </div>
</div>
